import { mockCheckoutMeta, mockCheckoutResult } from './mock'

export const previewModeCheckoutApi = ({ payload, req } = {}) => ({ result: { orderNumber: '#Mock-Order' } })

export const previewModeGetCheckoutMetaApi =
  ({ storeOrderId, req }) => ({ meta: mockCheckoutMeta })

export const previewModeGetCheckoutResultApi =
  ({ storeOrderId, req }) => ({ storeOrder: mockCheckoutResult })
